import { Button, Flex } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Popup } from "../../components";
import { ExamForm } from "../../forms";
import { usePopup } from "../../hooks/usePopup";
import ExamTable from "./ExamTable";
import { FilterIcon } from "../../assets";
import FilterForm from "../../forms/FilterForm";
import AppliedFilter from "../../forms/AppliedFilter";
import useUser from "../../hooks/useUser";
export default function Exam() {
  const examFormPopup = usePopup();
  const filterPopup = usePopup();

  const { examCreatePermission } = useUser();

  return (
    <>
      <Flex gap="large" wrap>
        <Popup
          ref={examFormPopup.popupRef}
          openTrigger={
            <Button disabled={!examCreatePermission} icon={<PlusOutlined />}>
              Add Exam
            </Button>
          }
        >
          <ExamForm popup={examFormPopup} />
        </Popup>

        <Popup
          ref={filterPopup.popupRef}
          openTrigger={
            <Button icon={<FilterIcon style={{ marginTop: 2 }} />}>
              Filter
            </Button>
          }
        >
          <FilterForm popup={filterPopup} />
        </Popup>
        <AppliedFilter />
      </Flex>
      <ExamTable />
    </>
  );
}
